module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "image-h"
  }, [_c('a', {
    attrs: {
      "id": "page_19"
    }
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "html/images/f0019-01.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "page_19"
    }
  }, [_c('p', {
    staticClass: "h3b",
    attrs: {
      "id": "lev22"
    }
  }, [_vm._v("THE ASS.")]), _vm._v(" "), _c('p', {
    staticClass: "chapauthor1"
  }, [_c('em', [_vm._v("(Equus Asinus")]), _vm._v(", Linn.—"), _c('em', [_vm._v("L’Ane")]), _vm._v(", Buff.)")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("THE ASS, it is probable, was originally a native of Arabia and other parts of the East: the deserts of Lybia and Numidia, and many parts of the Archipelago, contain vast herds of wild Asses, which run with such amazing swiftness, that even the fleetest Horses of the country can hardly overtake them. They are caught by the natives chiefly on account of their flesh, which is eaten by them, and considered as a delicious repast. The flesh of the common or tame Ass is, however, drier, and more tough and disagreeable than that of the Horse; Galen says, it is even unwholesome: its milk, on the contrary, is an approved remedy for certain disorders.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_19"
    }
  }, [_vm._v("The Ass, like the Horse, was originally imported into America by the Spaniards, where it has run wild, and become extremely numerous. Ulloa informs us, that in the kingdom of Quito, they hunt them in the following manner:—A number of ")]), _c('a', {
    attrs: {
      "id": "page_20"
    }
  }, [_vm._v("persons on horseback, attended by Indians on foot, form a large circle, in order to drive them into a narrow compass, where at full speed they throw a noose over them, and having secured them with fetters, leave them till the chase is over, which frequently lasts for several days.")])]), _c('a', {
    attrs: {
      "id": "page_20"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("A warm climate is most favourable to the growth of this animal: the Ass produced in this country is much inferior in size and beauty to those of Spain and other warm countries: in Guinea, they are larger and more beautiful than even their Horses: in Persia, they have two kinds,—the one slow and heavy, which is made use of for carrying burdens; the other nimble, smooth, and stately, used chiefly for the saddle.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Holingshed informs us that in the reign of queen Elizabeth, there were no Asses in this country: how soon after they might be introduced, is uncertain. However, they are at present naturalized in this kingdom, where their utility becomes daily more universally experienced.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The qualities of this animal are so well known, as to need no description: his gentleness, patience, and perseverance, are without example: he is temperate with regard to food, and eats contentedly the coarsest and most neglected herbage: if he give the preference to any vegetable, it is to the plantain, for which he will neglect every other herb in the pasture. In his water he is singularly nice, drinking only from the clearest brooks. He is so much afraid of wetting his feet, that, even when loaden, he will turn aside, to avoid the dirty parts of the road.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_20"
    }
  }, [_vm._v("He is stronger, in proportion to his size, than the Horse; but more sluggish, stubborn, and untractable. ")]), _c('a', {
    attrs: {
      "id": "page_21"
    }
  }, [_vm._v("He is hardier than the Horse; and of all other quadrupeds, is least infested with lice or other vermin; probably owing to the extreme hardness and dryness of his skin. For the same reason, perhaps, he is less sensitive of the lashes of the whip, or the stinging of flies.")])]), _c('a', {
    attrs: {
      "id": "page_21"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("He is three or four years in coming to perfection; and lives to the age of twenty, or sometimes twenty-five years. He sleeps much less than the Horse, and seldom lies down for that purpose but when he is much fatigued. The She-Ass goes eleven months with young, and seldom produces more than one at a time.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The services of this useful creature are too often repaid by hard fare and cruel usage; and being generally the property of the poor, it partakes of their wants and their distresses: whereas, by due cultivation and care in its education, the Ass might be usefully and profitably employed in a variety of domestic purposes, and in many cases supply the place of the Horse, to which only it is second, though generally degraded into the most useless and neglected of domestic quadrupeds.")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "html/images/f0021-01.jpg"
    }
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-787d25fc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/html/9780226044859_17_ch9.vue
// module id = 102
// module chunks = 0